export default "__VITE_ASSET__LeMlLfFk__"